export function normalizeMakeName(name, platformRagEnabled) {
  // If platform is RAG enabled then we're using JATO data and this data
  // doesn't contain the name mercedes-benz which AAIA does so we need
  // to cater for this by mapping it.
  if (platformRagEnabled) {
    const map = {
      'Mercedes-Benz': 'Mercedes',
      // Add more mappings as needed
    }

    if (typeof name !== 'string') return null

    const trimmed = name.trim()
    return map[trimmed] || trimmed
  }

  return name.trim()
}

export function normalizeModelName(name) {
  return typeof name === 'string' && name.trim() ? name.trim() : null
}
